import { render } from "./RecipientInput.vue?vue&type=template&id=47781e38&scoped=true"
import script from "./RecipientInput.vue?vue&type=script&lang=js"
export * from "./RecipientInput.vue?vue&type=script&lang=js"

import "./RecipientInput.vue?vue&type=style&index=0&id=47781e38&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47781e38"]])

export default __exports__